"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRider = void 0;
var superstruct_1 = require("superstruct");
var Timestamp_1 = require("../types/Timestamp");
var isStruct_1 = require("../utils/isStruct");
var RiderStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    phone: (0, superstruct_1.string)(),
    name: (0, superstruct_1.string)(),
    warehouseIds: (0, superstruct_1.optional)((0, superstruct_1.array)((0, superstruct_1.string)())),
    isOnDuty: (0, superstruct_1.boolean)(),
    isOnDutyUpdatedAt: Timestamp_1.TimestampStruct,
    assignedWarehouseId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    previousTaskId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    appVersion: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    appPlatformOs: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    appPlatformVersion: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    status: (0, superstruct_1.string)(),
    statusUpdatedAt: Timestamp_1.TimestampStruct,
    arrivedAtStoreAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
    leftStoreAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
    createdAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
    isThirdPartyProvider: (0, superstruct_1.boolean)(),
    thirdPartyProvider: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
function isRider(obj) {
    return (0, isStruct_1.isStruct)(obj, RiderStruct, "Rider");
}
exports.isRider = isRider;
